import { UserIdentity } from "./UserIdentity";

export class SurveySource {
    private origin;
    private deviceSerial: string;
    private patientId: string;

    public constructor(
        userIdentiy: UserIdentity,
        origin: string = "myair"
    ) {
        this.origin = origin;
        this.patientId = userIdentiy.patientIdIdentifier.patientId;

        if (userIdentiy.serialIdentifier) {
          this.deviceSerial = userIdentiy.serialIdentifier.serialNumber;
        }
    }
 }
